export const getLanguagesFromVoices = voices => {
  const arr = voices.map(elem => elem.language)
  return [...new Set(arr)]
}

export const getAgesFromVoices = voices => {
  const arr = voices.map(elem => elem.age)
  return [...new Set(arr)]
}